export default __webpack_public_path__ + "static/media/icon-awesome-search.9b012100.svg";